export const PageUrl = {
    PrivacyPolicy: {
        url: 'privacy-policy',
        urlWithSlash: '/privacy-policy'
    },
    // 外部AI事業者への個人情報の送信に関する説明書。
    // 個人情報保護法施行規則18条2項が本人への情報提供の方法として認める
    // 「ホームページに掲載し、本人に閲覧させる方法」に対応するため常時公開する。
    // 正本は ohana/aloha: pdf/契約時/_src/07_外部AI事業者への個人情報の送信に関する説明書.html
    AiDataTransfer: {
        url: 'ai-data-transfer',
        urlWithSlash: '/ai-data-transfer'
    },
    // 資料請求の専用ページ。トップのバナーおよび各所のCTAの着地点
    DocumentRequest: {
        url: 'document-request',
        urlWithSlash: '/document-request'
    },
    // SEO記事(コラム)の一覧。記事本体は /blog/<slug> で、
    // src/const/blog/index.ts の ARTICLES から自動で生える。
    // 記事を増やすときにこのファイルを触る必要はない。
    Blog: {
        url: 'blog',
        urlWithSlash: '/blog'
    },
    // 機能詳細(STEP 01〜06)の専用ページ。
    // トップページは概要カードだけに留めて縦を短くし、詳細を読みたい人だけここへ誘導する。
    Features: {
        url: 'features',
        urlWithSlash: '/features'
    },
}
